import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/faqs/index.md";
import * as React from 'react';
export default {
  Content,
  React
};